import { PLAN_TYPE_CODES, formatMetricPrice } from '../../utils';

export default function PlanMetricsList({
    plan,
    currencySymbol = '',
    listClassName = 'plan-metrics-list',
    iconClassName = 'check-icon',
}) {
    const symbol = plan?.currency_symbol || currencySymbol;

    if (Number(plan?.plan_type) === PLAN_TYPE_CODES[0].value && plan?.free_limits?.length > 0) {
        return (
            <ul className={listClassName}>
                {plan.free_limits.map((row) => (
                    <li key={row.type}>
                        <svg className={iconClassName} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                        </svg>
                        <span>
                            {row.type_label}: <strong>{row.limit_value.toLocaleString()}</strong> / mo included
                        </span>
                    </li>
                ))}
            </ul>
        );
    }

    if (Number(plan?.plan_type) === PLAN_TYPE_CODES[1].value && plan?.pricing?.length > 0) {
        return (
            <ul className={listClassName}>
                {plan.pricing.map((row) => (
                    <li key={row.type}>
                        <svg className={iconClassName} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                        </svg>
                        <span>
                            {row.type_label}: <strong>{formatMetricPrice(symbol, row.price)}</strong>
                            {row.type === 0 ? ' / mo base' : ' per unit'}
                        </span>
                    </li>
                ))}
            </ul>
        );
    }

    return null;
}
